export class Maintenance {
    static readonly GET_PROPERTY_ENTRIES_BY_CURRENT_TOKEN =
        '/api/Maintenance/httpGet_GetPropertyEntriesByCurrentToken';

    static readonly GET_NLOG_ENTRIES_BY_CURRENT_TOKEN =
        '/api/Maintenance/httpGet_GetNLogEntriesByCurrentToken';

    static readonly GET_AILOG_ENTRIES_BY_CURRENT_TOKEN =
        '/api/Maintenance/httpGet_GetAILogEntriesByCurrentToken';
}

export default Maintenance;
